import React, { useEffect } from 'react';
import Title from '../../constants/title';
import { Helmet } from 'react-helmet';

const GuestError = () => {

  return (
    <div className="flex items-center justify-center h-screen">
      <Helmet>
        <title>{Title.GUEST_RESERVATION}</title>
      </Helmet>
      <div className="flex flex-col items-center">
        <label className="text-lg font-bold text-center">
          セッション有効期限切れ
        </label>
        <div className="text-sm mt-8 flex flex-col flex-wrap text-center font-bold sm:mt-12 sm:flex-row">
          <label>
            一定時間操作がなかったため、セッションの有効期限が切れました。
          </label>
        </div>
        <label className="text-sm mt-3.5 whitespace-pre-wrap text-center font-medium sm:mt-8 lg:text-start">
          お手数ですが画面を閉じて初めからやりなおしてください。
        </label>
      </div>
    </div>
  );
};

export default GuestError;